module.exports = __webpack_public_path__ + "img/bossLogo.15c0cbc1.svg";